// extracted by mini-css-extract-plugin
module.exports = {"item":"_38zbUlFF _2IVOPH9e","open":"_3OnUg8Tp","closed":"T5B7pkbt","answer":"_3RmLxLoG _2p5x4XsD","sublist":"hFmQyMUA _2EfiFhQ- Hy3jAD3s"};